var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("component.dashboard.commonSettingsModal.title")) +
            " "
        ),
      ]),
    ]),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c(
          "b-field",
          {
            staticClass: "my-3",
            attrs: { horizontal: "" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("component.last_events.refresh")) +
                        " "
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c(
              "b-switch",
              {
                staticClass: "is-flex",
                model: {
                  value: _vm.isRefreshOn,
                  callback: function ($$v) {
                    _vm.isRefreshOn = $$v
                  },
                  expression: "isRefreshOn",
                },
              },
              [
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      type: "is-dark",
                      label: _vm.$tc(
                        "component.dashboard.commonSettingsModal.refreshNote",
                        _vm.intervalInMinute,
                        { value: _vm.intervalInMinute }
                      ),
                      position: "is-right",
                      multilined: "",
                    },
                  },
                  [
                    _c("b-icon", {
                      attrs: {
                        size: "is-small",
                        icon: "question-circle",
                        type: "is-grey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "footer",
      {
        staticClass: "modal-card-foot is-flex is-justify-content-space-between",
      },
      [
        _c(
          "b-button",
          {
            on: {
              click: function ($event) {
                return _vm.resultRetrieved()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("generals.close")) + " ")]
        ),
        _c(
          "b-button",
          {
            attrs: { type: "is-primary" },
            on: {
              click: function ($event) {
                return _vm.refreshChanged()
              },
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "component.public_dashboard.refreshSettings.saveSettings"
                  )
                ) +
                " "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }